import PropTypes from 'prop-types';

export const brandings = PropTypes.shape({
  cstore_brand_id: PropTypes.number,
  cstore_brand_logo_url: PropTypes.string,
  fuel_brand_id: PropTypes.number,
  fuel_brand_logo_url: PropTypes.string,
});

export default brandings;
